import { app } from '../../../bootstrap/core';
import appHeaderComponent from './appHeader.component';
import '../navbar/navbar';

app.component('appHeader', appHeaderComponent);
